export default __webpack_public_path__ + "static/media/stacksmith.eb839b94.svg";